"use client";

import { useIsomorphicLayoutEffect } from "cy-fe";
import { useHeaderContext } from "./HeaderContext";

export function HeaderOverrideContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const { setHeaderRender: setHeader } = useHeaderContext();
  useIsomorphicLayoutEffect(() => {
    setHeader(<>{children}</>);
    return () => {
      setHeader(undefined);
    };
  }, [setHeader]);
  return null;
}
